module.exports = __webpack_public_path__ + "img/file-1561744978418.d888f2f6.jpeg";